import React, { useCallback, useMemo, useRef, useState } from "react";
import Addicon from "../../../assets/images/FaPlus.svg";
import "./AddFile.css";
import Radio from "@mui/material/Radio";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import ButtonComponent from "../../../components/uikit/components/Button/ButtonComponent";
import { styled } from "@mui/material";
import { useSelector } from "react-redux";
import { formatDate } from "../../../assets/utils/utils";
import { formatFileSize } from "../MVOC/AttachmentMapper";
import CustomTooltip from "../../../components/uikit/components/Tooltip/Tooltip";

const AddFile = React.memo(({isAddFiles, onAddFile, onAttachmentUUIDChange, setAttachmentUUID}) => {
  const inputRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const AttachmentsRows = useSelector((state) => state?.mvocSlice?.attachmentRows);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 5,
  });

  // Memoized function to handle radio change
  const handleRadioChange = useCallback(
    (row) => {
      if (selectedRow?.id === row.id) return;
      setSelectedRow(row);
      console.log(row)
      onAttachmentUUIDChange(row?.id, row?.unified_id, row?.prompt_id,row?.prompt);
    },
    [selectedRow, onAttachmentUUIDChange]
  );
  // Memoized function to handle row click
  const handleRowClick = useCallback(
    (params) => {
      if (selectedRow?.id === params.row.id) return;
      setSelectedRow(params?.row);

      console.log(params?.row)
      onAttachmentUUIDChange(params?.row?.id, params?.row?.unified_id, params?.row?.prompt_id,params?.row?.prompt);
    },
    [selectedRow, onAttachmentUUIDChange]
  );
  const handlePaginationChange = useCallback((model) => {
    setPaginationModel(model);
}, []);
  // custom checkbox
  function customCheckbox(theme) {
    return {
      "& .MuiCheckbox-root": {
        height: 34,
        minHeight: 34,
      },
      "& .MuiCheckbox-root svg": {
        width: 16,
        height: 16,
        backgroundColor: "transparent",
        border: "none",
        borderRadius: 3,
        boxShadow: "0px 0px 2px rgba(0,0,0,0.3)",
      },
      "& .MuiCheckbox-root svg path": {
        display: "none",
      },
      "& .MuiCheckbox-root.Mui-checked:not(.MuiCheckbox-indeterminate) svg": {
        backgroundColor: "#5E5ADB",
        borderColor: "#5E5ADB",
      },
      "& .MuiCheckbox-root.Mui-checked .MuiIconButton-label:after": {
        position: "absolute",
        display: "table",
        border: "2px solid #fff",
        borderTop: 0,
        borderLeft: 0,
        transform: "rotate(45deg) translate(-50%,-50%)",
        opacity: 1,
        transition: "all .2s cubic-bezier(.12,.4,.29,1.46) .1s",
        content: '""',
        top: "50%",
        left: "39%",
        width: 5.71428571,
        height: 9.14285714,
      },
      "& .MuiCheckbox-root.MuiCheckbox-indeterminate .MuiIconButton-label:after":
        {
          width: 8,
          height: 8,
          backgroundColor: "#1890ff",
          transform: "none",
          top: "39%",
          border: 0,
        },
    };
  }
  const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    border: 0,
    color: "#25282B",
    fontFamily: "Montserrat",
    WebkitFontSmoothing: "auto",
    letterSpacing: "0.2px",
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#ffffff",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
      borderRight: 0,
    },
    "& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell": {
      borderBottom: "1px solid #E9EDF5",
    },
    "& .MuiDataGrid-cell": {
      color: "#25282B",
    },
    "& .MuiPaginationItem-root": {
      borderRadius: 0,
    },
    ...customCheckbox(theme),
  }));

  const filescolumns = useMemo(
    () => [
    {
      field: "selection",
      headerName: "",
      flex: 0.25,
      minWidth: 70,
      headerClassName: "quant-app-theme--header",
      cellClassName: "quant-app-theme--cell",
      renderCell: (params) => {
        const isSelected = params.row;
        return (
          <Radio
            type="radio"
            name="radio"
            value={params.row}
            checked={selectedRow?.id === params.row.id}
            onChange={() => handleRadioChange(params.row)}
          />
        );
      },
    },
    {
      field: "mvocDataFileName",
      textAlign: "center",
      headerName: "MVOC Map File",
      flex: 0.9,
      minWidth: 220,
      headerClassName: "quant-app-theme--header",
      cellClassName: "quant-app-theme--cell",
      renderCell: (params) => (
        <div>
          <CustomTooltip title={params.row.mvocDataFileName}>
            <div className="truncate-text">{params.row.mvocDataFileName}</div>
          </CustomTooltip>
          {params.row.mvocFileSize && (
            <div className="file-size">
              {formatFileSize(params.row.mvocFileSize)}
            </div>
          )}
        </div>
      ),
    },
    {
      field: "siFileName",
      headerName: "SI Mapping",
      flex: 0.9,
      minWidth: 220,
      headerClassName: "quant-app-theme--header",
      cellClassName: "quant-app-theme--cell",
      renderCell: (params) => (
        <div>
          <CustomTooltip title={params.row.siFileName}>
            <div className="truncate-text">{params.row.siFileName}</div>
          </CustomTooltip>
          {params.row.siFileSize && (
            <div className="file-size">
              {formatFileSize(params.row.siFileSize)}
            </div>
          )}
        </div>
      ),
    },
    {
      field: "owner",
      headerName: "Owner",
      flex: 0.5,
      minWidth: 150,
      headerClassName: "quant-app-theme--header",
      cellClassName: "quant-app-theme--cell",
    },
    {
      field: "prompt",
      headerName: "Prompt",
      flex: 0.5,
      minWidth: 150,
      headerClassName: "quant-app-theme--header",
      cellClassName: "quant-app-theme--cell",
    },
    {
      field: "wave",
      headerName: "Wave",
      flex: 0.5,
      minWidth: 150,
      headerClassName: "quant-app-theme--header",
      cellClassName: "quant-app-theme--cell",
    },
    {
      field: "createdAt",
      textAlign: "center",
      headerName: "Uploaded On",
      flex: 0.85,
      minWidth: 180,
      headerClassName: "quant-app-theme--header",
      cellClassName: "quant-app-theme--cell",
      renderCell: (params) => {
        const formattedDate = formatDate(params.row.createdAt, true);
        const datePart = formattedDate.split(" ").slice(0, 3).join(" ");
        const timePart = formattedDate.split(" ")[3];

        return (
          <div className="date-time-cell">
            <div>{datePart}</div>
            <div className="time">{timePart}</div>
          </div>
        );
      },
    },
  ],
  [handleRadioChange]
  );

  // Simplify the click handler
  const handleClick = useCallback((e) => {
    e.preventDefault();
    console.log('Button clicked in AddFile'); // Debug log
    onAddFile(); // Call the parent handler directly
  }, [onAddFile]);

  return (
    <div
      style={{
        pointerEvents: isAddFiles ? "none" : "auto",
        opacity: isAddFiles ? 0.5 : 1,
      }}
    >
      <div className="card-addfile w-100 border-none">
        <div className="w-100 h-100 position-relative mt-[15px]">
          <div
            className="d-flex justify-content-between"
            style={{ marginBottom: "2px" }}
          >
            <h4 className="project-title-text">Attachments</h4>
            <div
              className="long"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <img src={Addicon} alt="add" className="add-file-icon" />
              <ButtonComponent
                onClick={handleClick} // Use the simplified handler
                variant="contained"
                btnType="primary"
                text="Add File"
                className="btnPrimaryOutline"
                disabled={isAddFiles}
                sx={{
                  height: "35.11px !important",
                }}
              />
            </div>
          </div>
          <div className="file-datagrid">
            <StyledDataGrid
              rowHeight={48}
              rows={AttachmentsRows}
              columns={filescolumns}
              pagination
              paginationModel={paginationModel}
              onPaginationModelChange={handlePaginationChange}
              initialState={{
                pagination: { paginationModel: { pageSize: 5 } },
              }}
              pageSizeOptions={[5]}
              slots={{
                toolbar: () => (
                  <div ref={inputRef}>
                    <GridToolbarQuickFilter />
                  </div>
                ),
                GridToolbarQuickFilter,
              }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                },
              }}
              paginationMode="client"
              checkboxSelection={false}
              disableRowSelectionOnClick={true}
              onRowClick={handleRowClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
});

// Add displayName for better debugging
AddFile.displayName = 'AddFile';

export default AddFile;
